module.exports = __webpack_public_path__ + "static/img/partner6.4769336.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/partner6.png
// module id = houY
// module chunks = 0